<script>
import {mapGetters, mapState} from "vuex";
import Tile from '@/components/tile.vue';
import planCommon from './mixin';
import {BILLING_CYCLE, planTypes} from "@/common/constants";
import base from '@/views/config/addon-cards/templates/base.vue';
import {
  computedCallingPlans,
  computedPbxPlans,
  computedActiveCallingPlans
} from "@/common/service/computers/plans/pbx";
import store from '@/store';
import { isBizPlusContext, isProPlusContext } from '../ZOOM_MEETING/common/utils';
import ZoomPhonePowerPackLogo from '@/assets/plans/zoom_phone_power_pack.svg';

export default {
  name: 'ZoomPhonePowerPack',
  mixins: [base, planCommon],
  components: {
    Tile,
  },
  for: () => {
    if(isProPlusContext) return true;
    if(isBizPlusContext) return false;
    const mergePlanList = store.getters.getUserCurrentSubscriptions;
    const pbxCallingPlans = computedActiveCallingPlans(mergePlanList);
    return planTypes.map([planTypes.ZOOM_PHONE]) && pbxCallingPlans.length;
  },
  created() {
    if(this.defaultPlan) {
      const { amount, billing_cycle } = this.defaultPlan;
      this.subtitle = this.$money(amount) + this.$t(`billing.common.per_billing_cycle_license.${billing_cycle}`);
    }
  },

  data() {
    return {
      logo: ZoomPhonePowerPackLogo,
    };
  },

  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters({
      getSelectedPlans: 'getSelectedPlans',
      getUserCurrentSubscriptions: 'getUserCurrentSubscriptions',
    }),
    currentBillingCycle() {
      const selectCallingPlan = computedCallingPlans(this.getUserCurrentSubscriptions)[0];
      if(selectCallingPlan) {
        return selectCallingPlan.billing_cycle;
      }
      return BILLING_CYCLE.ANNUAL;
    },
    defaultPlan() {
      return computedPbxPlans(this.planMapFlat)
      .filter(item => item.category === 'ZPA')
      .find(item => item.billing_cycle === this.currentBillingCycle);
    },
  },
  watch: {
    defaultPlan(value) {
      if(value) {
        const { amount, billing_cycle } = value;
        this.subtitle = this.$money(amount) + this.$t(`billing.common.per_billing_cycle_license.${billing_cycle}`);
      }
    },
  },
};
</script>
